<ng-container *ngIf="config.visible && config.isVisible">
    <div class="row">
        <div class="col-lg-11">
            <ng-container *ngIf="config.label">
                <label [for]="config.id"><strong>{{ config.label }}</strong></label>
            </ng-container>
            <br />


            <ng-container
                *ngIf="config.multilangueFields || (!userService.userHasChampViewPermissionAccess(config.name,config.typeName))&& config.editMode">
                <div *ngFor="let local of languages">
                    <ng-container *ngIf="isLocal(local.key) && local.key !== 'all'">
                        <div class="d-flex">
                            <div>
                                <img src="/assets/images/Icones/flag/{{ local.key }}.svg" width="23" height="18"
                                    loading="lazy" />
                            </div>
                            <div class="mx-1">
                                <div class="row" style="margin-bottom: 20px; margin-bottom: 20px;">
                                    <div class="col-lg-11">
                                        <angular-editor [placeholder]="'Enter text here...'"
                                            [(ngModel)]=" multilangueMap[local.key]"
                                            [config]="EditorConfig"></angular-editor>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                    </ng-container>
                </div>
                <br />
            </ng-container>
        </div>
    </div>
</ng-container>
<br />